import React from "react";
import CadastroChavePix from "../../../components/acesso-rapido/pix/cadastrar-chave-pix/CadastroChavePix";

export default function () {
  return <CadastroChavePix />;
}
